import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { ListItemIcon, Box, ListItemButton } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { TooltipControlled } from "../../utils/TooltipControlled";
import { useState } from "react";
import FileUploadMenu from "./FileUploadMenu";
function FileUploadButtonMain({ disabled, callback, }) {
    return (_jsx(TooltipControlled, Object.assign({ enterDelay: 200, title: "Files", arrow: true, placement: "right" }, { children: _jsx(ListItemButton, Object.assign({ onClick: callback, disabled: disabled }, { children: _jsx(ListItemIcon, { children: _jsx(Box, Object.assign({ sx: { color: "secondary.light" } }, { children: _jsx(DriveFolderUploadIcon, {}) })) }) }), "save-current-nap-state") })));
}
const FileUploadButtonMenu = ({ disabled, handleOpenFiles, handleLoadPDB, handleLoadSmiles, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const menuIsOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(FileUploadButtonMain, { disabled: disabled, callback: handleClick }), _jsx(FileUploadMenu, { handleClose: handleClose, anchorEl: anchorEl, menuIsOpen: menuIsOpen, handleLoadFiles: handleOpenFiles, handleLoadPDB: handleLoadPDB, handleLoadSmiles: handleLoadSmiles })] }));
};
// export const FileUploadButton = ({
//   disabled,
//   callback,
// }: {
//   disabled: boolean;
//   callback: (x: any) => void;
// }) => {
//   return (
//     <TooltipControlled
//       enterDelay={200}
//       title="Load files"
//       arrow
//       placement="right"
//     >
//       <ListItemButton disabled={disabled} component="label">
//         <input
//           style={{ display: "none" }}
//           multiple
//           type="file"
//           id="multi-file-upload"
//           onChange={(e) => callback(e)}
//         />
//         <ListItemIcon>
//           <Box sx={{ color: "secondary.light" }}>
//             <DriveFolderUploadIcon />
//           </Box>
//         </ListItemIcon>
//       </ListItemButton>
//     </TooltipControlled>
//   );
// };
export default FileUploadButtonMenu;
